<script lang="ts" generics="Row">
  import { mdiMinusCircleOutline, mdiRestore } from "@mdi/js"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"

  type Props = {
    selectedRows?: Row[]
    resetRows: (rows: Row[]) => void
    removeRows: (rows: Row[]) => void
    clearSelection: () => void
    readOnly?: boolean
    disabled?: boolean
    isRowDisabled?: (row: Row) => boolean
    draftFor?: (row: Row) => unknown
    organizationId?: string | null
  }

  let {
    selectedRows = [],
    resetRows,
    removeRows,
    clearSelection,
    readOnly = false,
    disabled = false,
    isRowDisabled = (row) => Boolean((row as { disabled?: boolean }).disabled),
  }: Props = $props()

  const actionableRows = $derived(selectedRows.filter((row) => !isRowDisabled(row)))
  const isDisabled = $derived(readOnly || disabled || actionableRows.length <= 0)

  const handleReset = () => {
    if (isDisabled) return

    resetRows(actionableRows)
    clearSelection()
  }

  const handleRemove = () => {
    if (isDisabled) return

    removeRows(actionableRows)
    clearSelection()
  }
</script>

<div class="inbox-workflow-default-bulk-actions">
  <CTA
    type="secondaryButton"
    icon={mdiRestore}
    content="Zurücksetzen"
    disabled={isDisabled}
    tooltipContent={isDisabled
      ? "Die ausgewählten Zeilen können nicht zurückgesetzt werden."
      : "Ausgewählte Zeilen auf Anfangswerte zurücksetzen"}
    darkMode={false}
    onClick={handleReset}
  />
  <CTA
    type="secondaryButton"
    icon={mdiMinusCircleOutline}
    content="Entfernen"
    disabled={isDisabled}
    tooltipContent={isDisabled
      ? "Die ausgewählten Zeilen können nicht entfernt werden."
      : "Ausgewählte Zeilen aus diesem Durchlauf entfernen"}
    darkMode={false}
    onClick={handleRemove}
  />
</div>

<style>
  .inbox-workflow-default-bulk-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: flex-end;
    width: 100%;
  }
</style>
